module.exports = __webpack_public_path__ + "img/Andres_Henriquez_Perez.0641952a.jpeg";